import { render, staticRenderFns } from "./pbidConfirmForm.vue?vue&type=template&id=0904ec65&"
import script from "./pbidConfirmForm.vue?vue&type=script&lang=js&"
export * from "./pbidConfirmForm.vue?vue&type=script&lang=js&"
import style0 from "./pbidConfirmForm.vue?vue&type=style&index=0&id=0904ec65&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports